import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    {
      path: '*',
      redirect: { name: 'login' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      meta: {
        requiresVisitor: true,
      },
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'recover-password',
          path: 'recover-password',
          component: () => import('../components/auth/recover-password/RecoverPassword.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../components/pages/404-pages/VaPageNotFoundSimple.vue'),
    },
    {
      path: '/relogio',
      name: 'relogio',
      component: () => import('../components/live/components/Relogio.vue'),
    },
    {
      path: '/noticias',
      name: 'noticias',
      component: () => import('../components/live/components/Noticias.vue'),
    },
    {
      path: '/titulo',
      name: 'titulo',
      component: () => import('../components/live/components/Titulo.vue'),
    },
    {
      path: '/hashtag',
      name: 'hashtag',
      component: () => import('../components/live/components/Hashtag.vue'),
    },
    {
      path: '/subtitulo',
      name: 'subtitulo',
      component: () => import('../components/live/components/SubTitulo.vue'),
    },
    {
      path: '/classificacao',
      name: 'classificacao',
      component: () => import('../components/live/components/Classificacao.vue'),
    },
    {
      path: '/classificacao/:camp/:temp',
      name: 'classificacao-camp-temp',
      props: true,
      component: () => import('../components/live/components/Classificacao.vue'),
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
        },
        {
          name: 'my-perfil',
          path: 'my-perfil',
          component: () => import('../components/my-perfil/MyPerfil.vue'),
        },
        {
          name: 'users',
          path: 'users',
          component: () => import('../components/users/Users.vue'),
        },
        {
          name: 'chat-block',
          path: 'chat-block',
          component: () => import('../components/chat-block/ChatBlock.vue'),
        },
        {
          name: 'clients',
          path: 'clients',
          component: () => import('../components/clients/Clients.vue'),
        },
        {
          name: 'partners',
          path: 'partners',
          component: () => import('../components/partners/Partners.vue'),
        },
        {
          name: 'columnists',
          path: 'columnists',
          component: () => import('../components/columnists/Columnists.vue'),
        },
        {
          name: 'plans',
          path: 'plans',
          component: () => import('../components/plans/Plans.vue'),
        },
        {
          name: 'plan-add',
          path: 'plan-add',
          component: () => import('../components/plans/PlanAdd.vue'),
        },
        {
          name: 'plan-update',
          path: 'plan-update/:planId',
          props: true,
          component: () => import('../components/plans/PlanUpdate.vue'),
        },
        {
          name: 'trial',
          path: 'trial',
          component: () => import('../components/trial/Trial.vue'),
        },
        {
          name: 'trial-add',
          path: 'trial-add',
          component: () => import('../components/trial/TrialAddUpdate.vue'),
        },
        {
          name: 'plan-items',
          path: 'plan-items',
          component: () => import('../components/plan-items/PlanItems.vue'),
        },
        {
          name: 'app-features',
          path: 'app-features',
          component: () => import('../components/app-features/AppFeatures.vue'),
        },
        {
          name: 'rooms',
          path: 'rooms',
          component: () => import('../components/rooms/Rooms.vue'),
        },
        {
          name: 'rooms-order',
          path: 'rooms-order',
          component: () => import('../components/rooms/RoomsOrder.vue'),
        },
        {
          name: 'futebol',
          path: 'futebol',
          component: EmptyParentComponent,
          children: [
            {
              name: 'clubs',
              path: 'clubs',
              component: () => import('../components/clubs/Clubs.vue'),
            },
            {
              name: 'championships',
              path: 'championships',
              component: () => import('../components/championships/Championships.vue'),
            },
            {
              name: 'championships-order',
              path: 'championships-order',
              component: () => import('../components/championships/ChampionshipsOrder.vue'),
            },
            {
              name: 'seasons',
              path: 'championships/seasons/:championship',
              component: () => import('../components/seasons/Seasons.vue'),
              props: true,
            },
            {
              name: 'week-groups',
              path: 'week-groups',
              component: () => import('../components/week-group/WeeksGroup.vue'),
            },
            {
              name: 'week-groups-ranking-s1',
              path: 'week-groups/ranking-s1/:group',
              component: () => import('../components/week-group/WeeksGroupS1Ranking.vue'),
              props: true,
            },
            {
              name: 'week-groups-ranking',
              path: 'week-groups/ranking/:group',
              component: () => import('../components/week-group/WeeksGroupRanking.vue'),
              props: true,
            },
            {
              name: 'weeks',
              path: 'week-groups/weeks/:weekGroup',
              component: () => import('../components/weeks/Weeks.vue'),
              props: true,
            },
            {
              name: 'weeks-ranking-s1',
              path: 'weeks/ranking-s1/:week',
              component: () => import('../components/weeks/WeeksRankingS1Live.vue'),
              props: true,
            },
            {
              name: 'weeks-ranking',
              path: 'weeks/ranking/:week',
              component: () => import('../components/weeks/WeeksRanking.vue'),
              props: true,
            },
            {
              name: 'weeks-points',
              path: 'weeks/points/:week',
              component: () => import('../components/weeks/WeeksPoints.vue'),
              props: true,
            },
            {
              name: 'games',
              path: 'weeks/games/:week',
              component: () => import('../components/games/Games.vue'),
              props: true,
            },
            {
              name: 'gamesAPI',
              path: 'weeks/gamesAPI/:week',
              component: () => import('../components/games/GamesAPI.vue'),
              props: true,
            },
          ],
        },
        {
          name: 'sena',
          path: 'sena',
          component: EmptyParentComponent,
          children: [
            {
              name: 'sena-editions',
              path: 'editions',
              component: () => import('../components/sena/SenaEditions.vue'),
            },
            {
              name: 'sena-games',
              path: 'editions/games/:edition',
              component: () => import('../components/sena/SenaEditionGames.vue'),
              props: true,
            },
            {
              name: 'sena-games-pick',
              path: 'editions/games/:edition/pick',
              component: () => import('../components/sena/SenaEditionGamesPick.vue'),
              props: true,
            },
            {
              name: 'sena-tickets',
              path: 'editions/tickets/:edition',
              component: () => import('../components/sena/SenaEditionTickets.vue'),
              props: true,
            },
            {
              name: 'sena-ranking',
              path: 'editions/ranking/:edition',
              component: () => import('../components/sena/SenaEditionRanking.vue'),
              props: true,
            },
            {
              name: 'sena-settlement',
              path: 'editions/settlement/:edition',
              component: () => import('../components/sena/SenaEditionSettlement.vue'),
              props: true,
            },
            {
              name: 'sena-winners',
              path: 'editions/winners/:edition',
              component: () => import('../components/sena/SenaWinners.vue'),
              props: true,
            },
          ],
        },
        {
          name: 'partner-report',
          path: 'partner-report',
          props: true,
          component: () => import('../components/reports/PartnerReport.vue'),
        },
        {
          name: 'rewards',
          path: 'rewards',
          component: EmptyParentComponent,
          children: [
            {
              name: 'products',
              path: 'products',
              component: () => import('../components/products/Products.vue'),
            },
            {
              name: 'products-order',
              path: 'products-order',
              component: () => import('../components/products/ProductsOrder.vue'),
            },
            {
              name: 'rescues',
              path: 'rescues',
              component: () => import('../components/rescues/Rescues.vue'),
            },
            {
              name: 'stock',
              path: 'products/stock/:id',
              component: () => import('../components/products/ProductsStock.vue'),
              props: true,
            },
          ],
        },
        {
          name: 'reports',
          path: 'reports',
          component: EmptyParentComponent,
          children: [
            {
              name: 'report-partners',
              path: 'partners',
              component: () => import('../components/reports/Partners.vue'),
            },
            {
              name: 'partner-ano',
              path: 'partner/:partner/:ano',
              props: true,
              component: () => import('../components/reports/PartnerReport.vue'),
            },
            {
              name: 'partner-ano-mes',
              path: 'partner/:partner/:ano/:mes',
              props: true,
              component: () => import('../components/reports/PartnerReport.vue'),
            },
          ],
        },
        {
          name: 'live',
          path: 'live',
          component: EmptyParentComponent,
          children: [
            {
              name: 'liveComponents',
              path: 'liveComponents',
              component: () => import('../components/live/LiveComponents.vue'),
            },
          ],
        },
        {
          name: 'invoices',
          path: 'invoices',
          component: () => import('../components/invoices/Invoices.vue'),
        },
        {
          name: 'invoice-transactions',
          path: 'transactions/:invoiceId',
          props: true,
          component: () => import('../components/invoices/Transactions.vue'),
        },
        {
          name: 'transmissions',
          path: 'transmissions',
          component: () => import('../components/transmissions/Transmissions.vue'),
        },
        {
          name: 'notificacoes-link',
          path: 'notificacoes-link',
          component: () => import('../components/notificacoes-link/NotificacoesLink.vue'),
        },
        {
          name: 'club-videos',
          path: 'club-videos',
          component: () => import('../components/club-videos/ClubVideos.vue'),
        },
        {
          name: 'videos',
          path: 'videos',
          component: () => import('../components/videos/Videos.vue'),
        },
        {
          name: 'posts',
          path: 'posts',
          component: () => import('../components/posts/Posts.vue'),
        },
        {
          name: 'raffles',
          path: 'raffles',
          component: () => import('../components/raffles/Raffles.vue'),
        },
        {
          name: 'raffles-add',
          path: 'raffles-add',
          component: () => import('../components/raffles/RafflesAdd.vue'),
        },
        {
          name: 'raffles-update',
          path: 'raffles-update/:raffleId',
          props: true,
          component: () => import('../components/raffles/RafflesUpdate.vue'),
        },
        {
          name: 'raffles-tickets',
          path: 'raffles/tickets/:raffle',
          props: true,
          component: () => import('../components/raffles/RafflesTickets.vue'),
        },
        {
          name: 'raffle',
          path: 'raffles/raffle/:raffle',
          props: true,
          component: () => import('../components/raffles/Raffle.vue'),
        },
        {
          name: 'posts-add-update',
          path: 'postsAddUpdate',
          props: true,
          component: () => import('../components/posts/PostsAddUpdate.vue'),
        },
        {
          name: 'rss',
          path: 'rss',
          component: () => import('../components/rss/RSS.vue'),
        },
        {
          name: 'promotions',
          path: 'promotions',
          component: () => import('../components/promotions/Promotions.vue'),
        },
        {
          name: 'settings',
          path: 'settings',
          component: () => import('../components/settings/Settings.vue'),
        },
        {
          name: 'statistics',
          path: 'statistics',
          component: EmptyParentComponent,
          children: [
            {
              name: 'charts',
              path: 'charts',
              component: () => import('../components/statistics/charts/Charts.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
            },
            {
              name: 'progress-bars',
              path: 'progress-bars',
              component: () => import('../components/statistics/progress-bars/ProgressBars.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Progress-Bars',
              },
            },
          ],
        },
        {
          name: 'forms',
          path: 'forms',
          component: EmptyParentComponent,
          children: [
            {
              name: 'form-elements',
              path: 'form-elements',
              component: () => import('../components/forms/form-elements/FormElements.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/inputs',
              },
            },
            {
              name: 'medium-editor',
              path: 'medium-editor',
              component: () => import('../components/forms/medium-editor/MediumEditor.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
          ],
        },
        {
          name: 'tables',
          path: 'tables',
          component: EmptyParentComponent,
          children: [
            {
              name: 'markup',
              path: 'markup',
              component: () => import('../components/markup-tables/MarkupTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables',
            },
            {
              name: 'data',
              path: 'data',
              component: () => import('../components/data-tables/DataTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables',
            },
          ],
        },
        {
          name: 'ui',
          path: 'ui',
          component: EmptyParentComponent,
          children: [
            {
              name: 'typography',
              path: 'typography',
              component: () => import('../components/ui/typography/Typography.vue'),
            },
            {
              name: 'buttons',
              path: 'buttons',
              component: () => import('../components/ui/buttons/Buttons'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Buttons',
              },
            },
            {
              name: 'rating',
              path: 'rating',
              component: () => import('../components/ui/rating/Rating'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Rating',
              },
            },
            {
              name: 'color-pickers',
              path: 'color-pickers',
              component: () => import('../components/ui/color-pickers/ColorPickers'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Color-Pickers',
              },
            },
            {
              name: 'timelines',
              path: 'timelines',
              component: () => import('../components/ui/timelines/Timelines'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Timelines',
              },
            },
            {
              name: 'notifications',
              path: 'notifications',
              component: () => import('../components/ui/notifications/Notifications'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Notifications',
              },
            },
            {
              path: 'icons',
              component: () => import('../components/ui/icons/Icons'),
              children: [
                {
                  name: 'icon-sets',
                  path: '', // Default route
                  component: () => import('../components/ui/icons/SetsList'),
                  meta: {
                    wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
                {
                  name: 'icon-set',
                  path: ':name',
                  component: () => import('../components/ui/icons/IconSet'),
                  props: true,
                  meta: {
                    wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
              ],
            },
            {
              name: 'spinners',
              path: 'spinners',
              component: () => import('../components/ui/spinners/Spinners'),
            },
            {
              name: 'grid',
              path: 'grid',
              component: () => import('../components/ui/grid/Grid'),
            },
            {
              name: 'modals',
              path: 'modals',
              component: () => import('../components/ui/modals/Modals'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Modals',
              },
            },
            {
              name: 'cards',
              path: 'cards',
              component: () => import('../components/ui/cards/Cards'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Cards',
              },
            },
            {
              name: 'file-upload',
              path: 'file-upload',
              component: () => import('../components/ui/file-upload/FileUpload'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/File-Upload',
              },
            },
            {
              name: 'chips',
              path: 'chips',
              component: () => import('../components/ui/chips/Chips'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Chips',
              },
            },
            {
              name: 'tree-view',
              path: 'tree-view',
              component: () => import('../components/ui/tree-view/TreeView'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tree-view',
              },
            },
            {
              name: 'collapses',
              path: 'collapses',
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Collapse',
              },
              component: () => import('../components/ui/collapse/Collapses'),
            },
            {
              name: 'colors',
              path: 'colors',
              component: () => import('../components/ui/colors/Colors'),
            },
            {
              name: 'spacing',
              path: 'spacing',
              component: () => import('../components/ui/spacing/Spacing'),
            },
            {
              name: 'sliders',
              path: 'sliders',
              component: () => import('../components/ui/sliders/Sliders'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Sliders',
              },
            },
            {
              name: 'popovers',
              path: 'popovers',
              component: () => import('../components/ui/popovers/Popovers'),
            },
            {
              name: 'chat',
              path: 'chatPage',
              component: () => import('../components/ui/chat/ChatPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Chat',
              },
            },
            {
              name: 'tabs',
              path: 'tabs',
              component: () => import('../components/ui/tabs/Tabs'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tabs',
              },
            },
            {
              name: 'lists',
              path: 'lists',
              component: () => import('../components/lists/Lists.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Lists',
              },
            },
          ],
        },
        {
          name: 'maps',
          path: 'maps',
          component: EmptyParentComponent,
          children: [
            {
              name: 'google-maps',
              path: 'google-maps',
              component: () => import('../components/maps/google-maps/GoogleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'yandex-maps',
              path: 'yandex-maps',
              component: () => import('../components/maps/yandex-maps/YandexMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'leaflet-maps',
              path: 'leaflet-maps',
              component: () => import('../components/maps/leaflet-maps/LeafletMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'bubble-maps',
              path: 'bubble-maps',
              component: () => import('../components/maps/bubble-maps/BubbleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'line-maps',
              path: 'line-maps',
              component: () => import('../components/maps/line-maps/LineMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
          ],
        },
        {
          name: 'pages',
          path: 'pages',
          component: EmptyParentComponent,
          children: [
            {
              name: '404-pages',
              path: '404-pages',
              component: () => import('../components/pages/404-pages/404PagesPage'),
            },
          ],
        },
      ],
    },
  ],
})
